import { useParams } from 'react-router-dom'

import { useQuery } from '@apollo/client/react/hooks/useQuery'
import { TrainingMembershipCompletionDateDocument } from 'generated/resources/graphql'

import { EditCompletionDateModal } from 'modules/trainings/components/Revamp/TrainingsDetail/TrainingEmployeesDataTable/EditCompletionDateModal'

const UpdateCompletionDate = () => {
  const { membershipId, id } = useParams()
  const { data } = useQuery(TrainingMembershipCompletionDateDocument, {
    variables: { id: String(membershipId) },
  })
  const completionDate = data?.trainings?.trainingMembership?.trainingCompletedAt
  return (
    <EditCompletionDateModal
      id={String(id)}
      completionDate={completionDate ?? ''}
      membershipId={String(membershipId)}
    />
  )
}

export default UpdateCompletionDate
